import { render, staticRenderFns } from "./LoginGuidance.vue?vue&type=template&id=28f74cda&scoped=true&"
import script from "./LoginGuidance.vue?vue&type=script&lang=js&"
export * from "./LoginGuidance.vue?vue&type=script&lang=js&"
import style0 from "./LoginGuidance.vue?vue&type=style&index=0&id=28f74cda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f74cda",
  null
  
)

export default component.exports